import { useAsyncExecutor } from "async-executor-hook";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { BodyContainerTableCommon } from "../../../common/components/TableResponsive";
import {
  onlyLetterNumberCharacterGuion,
  WInputText,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import { getErrorValueResponse } from "../../../common/error/Error";
import { removeNullProps } from "../../../common/utils";
import { HTTP_METHODS } from "../../../utils/constants";
import { networkBackendRequest } from "../../../utils/networkUtils";
import { ContainerInputs, ContainerTitleSync } from "../SyncronizeDataStyled";

interface IcreateUserManifestParams {
  to_date: string;
  from_date: string;
  manifest_num: string;
  succeed?: any;
  failed?: any;
}

export const SyncronizeManifestNum = () => {
  const toast: any = useRef();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        manifest_num: new FormControl(),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form, { processing, succeed, failed }) => {
      if (form.invalid) {
        toast.current.show({
          severity: "error",
          summary:
            "Completar todos los campos obligatorios antes de continuar. ¡Gracias!",
          contentClassName: "",
        });
        return;
      }
      processing();
      createUserExecutor.execute({
        ...form.value,
        succeed,
        failed,
      });
    },
  });
  const createUserExecutor = useAsyncExecutor(
    (params: IcreateUserManifestParams) => {
      const { manifest_num } = params;
      const urlPostManifestNum = `/sync-engine/manual-synchronization/${manifest_num}/manifest-num`;
      return networkBackendRequest(
        urlPostManifestNum,
        HTTP_METHODS.POST,
        removeNullProps({ manifest_num })
      ).then((resp) => resp.json());
    },
    {
      onSuccess: (_, params: IcreateUserManifestParams) => {
        params.succeed();
        formConfig.loadSucceed({});
        toast.current.show({
          severity: "success",
          summary: "Success Message",
          detail: `La sincronización de ${params.manifest_num} se realizó con éxito.`,
          life: 5000,
        });
      },
      onError(error, params: IcreateUserManifestParams) {
        const errorMessage = getErrorValueResponse(error);
        params.failed();
        toast.current.show({
          severity: "error",
          summary: "Atención",
          detail: errorMessage,
          life: 3000,
        });
      },
    }
  );

  useEffect(() => {
    formConfig.loadSucceed({});
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <Toast ref={toast}></Toast>
      <WForm formConfig={formConfig} style={{ width: "100%" }}>
        <BodyContainerTableCommon className="item-container" height="10rem">
          <div
            className="attribute"
            style={{
              display: "flex",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            <div className="titles">{"Sincronizar"}</div>
            <ContainerTitleSync>
              <div style={{ fontSize: "1.6rem", color: "#2E353D" }}>
                Por N° Manifiesto
              </div>
              <div style={{ fontSize: "1.2rem", color: "#989CA2" }}>
                <p style={{ maxWidth: "27rem" }}>
                  Sincronice la información de la carga en base al{" "}
                  <strong>número de manifiesto.</strong>
                </p>
              </div>
            </ContainerTitleSync>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"PARÁMETROS DE SINCRONIZACIÓN"}</div>
            <div className="left-align" style={{ width: "100%" }}>
              <ContainerInputs>
                <div>
                  <WFormControl name="manifest_num">
                    <TemplateInputContainer
                      label="Nº Manifiesto"
                      color="#002E6C"
                    >
                      <WInputText
                        width="20rem"
                        height="4rem"
                        fontSize="1.4rem"
                        placeholder="2023-12345"
                        onKeyPress={onlyLetterNumberCharacterGuion}
                      />
                    </TemplateInputContainer>
                  </WFormControl>
                </div>
                <div></div>
              </ContainerInputs>
            </div>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"ACCIONES"}</div>
            <div className="left-align">
              <SaveButton
                label="Sincronizar"
                width="17rem"
                height="3.8rem"
                fontSize="1.5rem"
                backgroundColor="#002E6C"
                isDisabled={formConfig?.form?.value.manifest_num < 1}
              />
            </div>
          </div>
        </BodyContainerTableCommon>
      </WForm>
    </div>
  );
};
